import { FunctionComponent, SVGProps } from 'react';

import { Theme } from '@mui/material';

import { ReactComponent as MediaPlansIcon } from '@/assets/icons/media-plans-icon.svg';
import { ReactComponent as PackagesIcon } from '@/assets/icons/menu-adv-packages.svg';
import { ReactComponent as SpacesIcon } from '@/assets/icons/menu-adv-spaces.svg';
import { ReactComponent as ClientsIcon } from '@/assets/icons/menu-clients-icon.svg';
import { ReactComponent as CompaniesIcon } from '@/assets/icons/menu-companies-icon.svg';
import { ReactComponent as LocationsIcon } from '@/assets/icons/menu-locations.svg';
import { ReactComponent as OrdersIcon } from '@/assets/icons/reservations-icon.svg';
import { ReactComponent as UsersIcon } from '@/assets/icons/users-icon.svg';

import { SearchCategory } from '../model/types';

type PaletteShadeKey = 'purple' | 'magenta' | 'blue' | 'green' | 'orange' | 'red' | 'grey';

interface CategoryVisualConfig {
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  palette: PaletteShadeKey;
  thumbShade?: 100 | 200;
  thumbIconShade?: 600 | 700;
}

const VISUALS: Record<SearchCategory, CategoryVisualConfig> = {
  ORDER: { Icon: OrdersIcon, palette: 'orange', thumbShade: 200, thumbIconShade: 600 },
  MEDIA_PLAN: { Icon: MediaPlansIcon, palette: 'blue' },
  SPACE: { Icon: SpacesIcon, palette: 'purple' },
  PACKAGE: { Icon: PackagesIcon, palette: 'magenta' },
  LOCATION: { Icon: LocationsIcon, palette: 'green', thumbShade: 200 },
  CLIENT: { Icon: ClientsIcon, palette: 'purple' },
  COMPANY: { Icon: CompaniesIcon, palette: 'grey' },
  USER: { Icon: UsersIcon, palette: 'blue' },
};

export interface SearchCategoryVisual {
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  thumbColor: (theme: Theme) => string;
  thumbBackground: (theme: Theme) => string;
  heroBackground: (theme: Theme) => string;
}

export function getSearchCategoryVisual(category: SearchCategory): SearchCategoryVisual {
  const { Icon, palette, thumbShade, thumbIconShade } = VISUALS[category];

  return {
    Icon,
    thumbColor: (theme) => theme.palette[palette][thumbIconShade ?? 700],
    thumbBackground: (theme) => theme.palette[palette][thumbShade ?? 100],
    heroBackground: (theme) => theme.palette[palette][100],
  };
}
